import { memo } from "react";
import "./PaymentDueSummary.scss";
import { FormattedDate, FormattedMessage } from "react-intl";
import propTypes from "prop-types";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import AmountContainer from "app/pages/.shared/AmountContainer.jsx";
import { PAYMENT_TERMS } from "app/constants";

const PaymentDueSummary = ({ payNowAmount, payAtPropertyAmount, paymentMode, mensualite2Fois }) => {
	if (!payNowAmount) {
		return null;
	}

	const is2xPaymentMode = paymentMode === PAYMENT_TERMS["2x"];

	const secondPaymentDueDate = is2xPaymentMode && mensualite2Fois?.dueDate;
	const secondPaymentAmount = is2xPaymentMode && mensualite2Fois?.payLaterAmount;

	const parsedSecondPaymentDueDate = new Date(secondPaymentDueDate);
	const isSecondPaymentDueDateValid = !isNaN(parsedSecondPaymentDueDate.getTime());

	return (
		<div className="payment-due-summary" data-testId="payment-due-summary">
			<div className="payment-due-summary__item">
				<Typography variant={TYPOGRAPHY_VARIANTS.LARGE} component="p" isBold>
					<FormattedMessage id="my.bookings.pay.now.label" />
				</Typography>

				<Typography variant={TYPOGRAPHY_VARIANTS.LARGE} component="p" isBold>
					<AmountContainer amount={payNowAmount} />
				</Typography>
			</div>

			{isSecondPaymentDueDateValid && secondPaymentAmount > 0 && (
				<div className="payment-due-summary__item">
					<Typography component="p" variant={TYPOGRAPHY_VARIANTS.REGULAR}>
						<FormattedMessage
							id="payment.pay.later.amount"
							values={{
								dueDate: (
									<FormattedDate
										timeZone="UTC"
										value={parsedSecondPaymentDueDate}
										year="numeric"
										month="2-digit"
										day="2-digit"
									/>
								),
							}}
						/>
					</Typography>

					<Typography component="p" variant={TYPOGRAPHY_VARIANTS.REGULAR}>
						<AmountContainer className="amount--normal" amount={secondPaymentAmount} />
					</Typography>
				</div>
			)}

			{payAtPropertyAmount > 0 && (
				<div className="payment-due-summary__item">
					<Typography component="p" variant={TYPOGRAPHY_VARIANTS.REGULAR}>
						<FormattedMessage id="pay.at.property" />
					</Typography>

					<Typography component="p" variant={TYPOGRAPHY_VARIANTS.REGULAR}>
						<AmountContainer className="amount--normal" amount={payAtPropertyAmount} />
					</Typography>
				</div>
			)}
		</div>
	);
};

PaymentDueSummary.propTypes = {
	payNowAmount: propTypes.number,
	payAtPropertyAmount: propTypes.number,
	paymentMode: propTypes.number,
	mensualite2Fois: propTypes.object,
};

export default memo(PaymentDueSummary);
